/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Showcase_Defininggame1Inputs */

const id_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game penentu`)
};

const ms_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan penentu`)
};

const da_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definerende spil`)
};

const de_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definierendes Spiel`)
};

const en_us2_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defining game`)
};

const es_es2_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego definitorio`)
};

const es_mx2_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego definitorio`)
};

const fil_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangunahing laro`)
};

const fr_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeu emblématique`)
};

const it_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioco distintivo`)
};

const hu_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meghatározó játék`)
};

const nl_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bepalende game`)
};

const no_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definerende spill`)
};

const pl_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gra definiująca`)
};

const pt_br2_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definindo jogo`)
};

const pt_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo definidor`)
};

const ro_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joc definitoriu`)
};

const fi_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Määrittelevä peli`)
};

const sv_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definierande spel`)
};

const vi_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game định hình`)
};

const tr_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanımlayıcı oyun`)
};

const cs_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definující hra`)
};

const bg_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Определяща игра`)
};

const ru_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Определяющая игра`)
};

const uk_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Визначальна гра`)
};

const ar_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللعبة المميزة`)
};

const hi_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिभाषित गेम`)
};

const th_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมที่เป็นตัวกำหนด`)
};

const ja_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代表的なゲーム`)
};

const zh_cn2_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代表游戏`)
};

const zh_hant1_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代表遊戲`)
};

const ko_profile_showcase_defininggame1 = /** @type {(inputs: Profile_Showcase_Defininggame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대표 게임`)
};

/**
* | output |
* | --- |
* | "Defining game" |
*
* @param {Profile_Showcase_Defininggame1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_defininggame1 = /** @type {((inputs?: Profile_Showcase_Defininggame1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Defininggame1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_defininggame1(inputs)
	if (locale === "ms") return ms_profile_showcase_defininggame1(inputs)
	if (locale === "da") return da_profile_showcase_defininggame1(inputs)
	if (locale === "de") return de_profile_showcase_defininggame1(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_defininggame1(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_defininggame1(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_defininggame1(inputs)
	if (locale === "fil") return fil_profile_showcase_defininggame1(inputs)
	if (locale === "fr") return fr_profile_showcase_defininggame1(inputs)
	if (locale === "it") return it_profile_showcase_defininggame1(inputs)
	if (locale === "hu") return hu_profile_showcase_defininggame1(inputs)
	if (locale === "nl") return nl_profile_showcase_defininggame1(inputs)
	if (locale === "no") return no_profile_showcase_defininggame1(inputs)
	if (locale === "pl") return pl_profile_showcase_defininggame1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_defininggame1(inputs)
	if (locale === "pt") return pt_profile_showcase_defininggame1(inputs)
	if (locale === "ro") return ro_profile_showcase_defininggame1(inputs)
	if (locale === "fi") return fi_profile_showcase_defininggame1(inputs)
	if (locale === "sv") return sv_profile_showcase_defininggame1(inputs)
	if (locale === "vi") return vi_profile_showcase_defininggame1(inputs)
	if (locale === "tr") return tr_profile_showcase_defininggame1(inputs)
	if (locale === "cs") return cs_profile_showcase_defininggame1(inputs)
	if (locale === "bg") return bg_profile_showcase_defininggame1(inputs)
	if (locale === "ru") return ru_profile_showcase_defininggame1(inputs)
	if (locale === "uk") return uk_profile_showcase_defininggame1(inputs)
	if (locale === "ar") return ar_profile_showcase_defininggame1(inputs)
	if (locale === "hi") return hi_profile_showcase_defininggame1(inputs)
	if (locale === "th") return th_profile_showcase_defininggame1(inputs)
	if (locale === "ja") return ja_profile_showcase_defininggame1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_defininggame1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_defininggame1(inputs)
	return ko_profile_showcase_defininggame1(inputs)
});
export { profile_showcase_defininggame1 as "profile.showcase.definingGame" }